/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Checkliste { 
    hat_buchungen?: boolean;
    checkliste_id: string;
    funktionsbereich_id: string;
    titel: string;
    vorlage_checkliste_id: string;
    reihenfolge?: number;
    freigabe_rollen_ids?: Array<string>;
    abarbeitung_rollen_ids?: Array<string>;
    lese_rollen_ids?: Array<string>;
    veranstaltung_id: string;
    mandant_id?: string;
    modified_on_utc?: Date;
}

